import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Grid,
  GridItem,
} from "@chakra-ui/react";

import { LicenseInfo } from "../../../../types/requestCreditDataTypes";
import { useBranch } from "../../../../data/user";

interface LicenseStepProps {
  savedData: LicenseInfo | undefined;
  updateData: (data: LicenseInfo) => void;
}

// Format date to DD/MM/YYYY
const formatDate = (date: Date): string => {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const parseDate = (dateString: string) => {
  const [day, month, year] = dateString.split("/").map(Number);
  return new Date(year, month - 1, day);
};

const toInputFormat = (date: Date): string => {
  return date.toISOString().split("T")[0];
};

// Default license info values
const defaultLicenseInfo: LicenseInfo = {
  license_number: "",
  license_expiration: "",
  vat_number: "",
  vat_expiration: "",
};

const LicenseStep: React.FC<LicenseStepProps> = ({ savedData, updateData }) => {
  const licenseInfo = { ...defaultLicenseInfo, ...savedData }; // ensure all fields exist
  const { branch } = useBranch();

  return (
    <Box>
      <Grid templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }} gap={5}>
        <GridItem colSpan={{ base: 1, md: 2 }}>
          <FormControl isRequired>
            <FormLabel>Licence Number</FormLabel>
            <Input
              type="number"
              isInvalid={!licenseInfo.license_number}
              value={licenseInfo.license_number}
              placeholder={
                branch === "UAE"
                  ? "As per trade license"
                  : "Enter License Number"
              }
              onChange={(e) => {
                updateData({
                  ...licenseInfo,
                  license_number: e.target.value,
                });
              }}
            />
          </FormControl>
        </GridItem>

        <GridItem colSpan={1}>
          <FormControl isRequired>
            <FormLabel>Licence Expiration Date</FormLabel>
            <Input
              type="date"
              isInvalid={!licenseInfo.license_expiration}
              value={
                licenseInfo.license_expiration
                  ? toInputFormat(parseDate(licenseInfo.license_expiration))
                  : ""
              }
              onChange={(e) => {
                updateData({
                  ...licenseInfo,
                  license_expiration: formatDate(new Date(e.target.value)),
                });
              }}
            />
          </FormControl>
        </GridItem>

        <GridItem colSpan={{ base: 1, md: 2 }}>
          <FormControl>
            <FormLabel>VAT Number</FormLabel>
            <Input
              type="number"
              isInvalid={!licenseInfo.vat_number}
              value={licenseInfo.vat_number}
              onChange={(e) => {
                updateData({
                  ...licenseInfo,
                  vat_number: e.target.value,
                });
              }}
            />
          </FormControl>
        </GridItem>

        <GridItem colSpan={1}>
          <FormControl>
            <FormLabel>VAT Expiration Date</FormLabel>
            <Input
              type="date"
              isInvalid={!licenseInfo.vat_expiration}
              value={
                licenseInfo.vat_expiration
                  ? toInputFormat(parseDate(licenseInfo.vat_expiration))
                  : ""
              }
              onChange={(e) => {
                updateData({
                  ...licenseInfo,
                  vat_expiration: formatDate(new Date(e.target.value)),
                });
              }}
            />
          </FormControl>
        </GridItem>
      </Grid>
    </Box>
  );
};

export default LicenseStep;
